import adminHttp from "@/api/adminHttp";

const ADMIN_END_POINT = '/api/v1/admin';
const CLIENT_END_POINT = '/api/v1/client';

/**
 * MMR игрока в MLBB. Рейтинг привязан к игровому ID, а не к аккаунту:
 * при перепривязке Game ID рейтинг и история переезжают вместе с ним.
 *
 * Чтение лежит в клиентской части — своих админских ручек для него нет.
 */
export default {
    // 404 — у игрока не привязан MLBB ID.
    show: (userId) => adminHttp.get(CLIENT_END_POINT + `/mlbb/mmr/players/${userId}`),

    history: (userId, params = {}) =>
        adminHttp.get(CLIENT_END_POINT + `/mlbb/mmr/players/${userId}/history`, {params}),

    // Требует права mlbb-mmr update. Ответ 201 — созданная запись истории.
    update: (userId, payload) =>
        adminHttp.patch(ADMIN_END_POINT + `/mlbb/mmr/players/${userId}`, payload),
}
